import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  TextField
} from '@mui/material'
import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import { useCreateQuickAction } from 'app/hooks/useQuickActionQueries'
import { QuickActionType } from 'app/services/quickActionApi'
import Attachments from '../Attachments'

interface Props extends RouteComponentProps {
  sampleNumber?: number
  unitId?: number
  componentId?: number
  customerId?: number
  siteId?: number
  label?: string
}

const actions: Array<{ label: string; type: QuickActionType }> = [
  { label: 'Update sample details', type: 'sample-details' },
  { label: 'Component change out', type: 'component-changeout' },
  { label: 'Unit meter change out', type: 'unit-meter-changeout' },
  { label: 'Update unit details', type: 'unit-details' },
  { label: 'Make general note', type: 'unit-note' }
]

const QuickActions = (props: Props) => {
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null)
  const [actionType, setActionType] = React.useState<QuickActionType | null>(null)
  const [notes, setNotes] = React.useState('')
  const [workOrderNumber, setWorkOrderNumber] = React.useState('')
  const createQuickAction = useCreateQuickAction()

  const openAction = (type: QuickActionType) => {
    setAnchor(null)
    setActionType(type)
  }

  const closeDialog = () => {
    setActionType(null)
    setNotes('')
    setWorkOrderNumber('')
  }

  const submit = async () => {
    if (!actionType || !notes.trim()) return

    await createQuickAction.mutateAsync({
      actionType,
      sampleNumber: props.sampleNumber,
      unitId: props.unitId,
      componentId: props.componentId,
      notes,
      workOrderNumber
    })
    closeDialog()
  }

  const registrationUrl =
    props.customerId && props.siteId && props.unitId
      ? `/sample-registration?customer=${props.customerId}&site=${props.siteId}&unit=${props.unitId}`
      : '/sample-registration'
  const attachmentOwner =
    props.sampleNumber ? { ownerType: 'sample' as const, ownerId: props.sampleNumber } :
    props.unitId ? { ownerType: 'unit' as const, ownerId: props.unitId } :
    null

  return (
    <>
      <Button size="small" variant="outlined" onClick={(event) => setAnchor(event.currentTarget)}>
        {props.label || 'Actions'}
      </Button>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {actions.map((action) => (
          <MenuItem key={action.type} onClick={() => openAction(action.type)}>
            {action.label}
          </MenuItem>
        ))}
        <MenuItem onClick={() => props.history.push(registrationUrl)}>Go to registration</MenuItem>
      </Menu>
      <Dialog open={!!actionType} onClose={closeDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{actions.find((action) => action.type === actionType)?.label}</DialogTitle>
        <DialogContent>
          <TextField
            label="Work order"
            value={workOrderNumber}
            onChange={(event) => setWorkOrderNumber(event.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Details"
            value={notes}
            onChange={(event) => setNotes(event.target.value)}
            fullWidth
            required
            multiline
            minRows={4}
            margin="normal"
          />
          {attachmentOwner && (
            <Attachments
              ownerType={attachmentOwner.ownerType}
              ownerId={attachmentOwner.ownerId}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!notes.trim() || createQuickAction.isPending}
            onClick={submit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default withRouter(QuickActions)
